module.exports = __webpack_public_path__ + "static/media/closed.1d3acfc0.svg";